module.exports = __webpack_public_path__ + "static/media/Lateral_NES_Z2.c5698b6a.png";